import { render, staticRenderFns } from "./SalesManagerView.vue?vue&type=template&id=46dca19e&scoped=true&"
import script from "./SalesManagerView.vue?vue&type=script&lang=ts&"
export * from "./SalesManagerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dca19e",
  null
  
)

export default component.exports